import { render, staticRenderFns } from "./AuctionStatusLabel.vue?vue&type=template&id=110a99c9&scoped=true&"
import script from "./AuctionStatusLabel.vue?vue&type=script&lang=ts&"
export * from "./AuctionStatusLabel.vue?vue&type=script&lang=ts&"
import style0 from "./AuctionStatusLabel.vue?vue&type=style&index=0&id=110a99c9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110a99c9",
  null
  
)

export default component.exports